import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import {
  fetchFaqDetail, createFaq, updateFaq, fetchFaqCategories,
} from 'actions/Faq'
import FormFaqListView from 'components/pages/faq/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchFaqDetail: bindActionCreators(fetchFaqDetail, dispatch),
  createFaq: bindActionCreators(createFaq, dispatch),
  updateFaq: bindActionCreators(updateFaq, dispatch),
  fetchFaqCategories: bindActionCreators(fetchFaqCategories, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withState('imgFile', 'setImgFile', ''),
  withState('currentImg', 'setCurrentImg', ''),
  withState('data', 'setData', {}),
  withState('categoryList', 'setCategoryList', {
    data: [],
    isFetching: true,
  }),
  withHandlers({
    getCategoryList: props => async (params) => {
      const { setCategoryList } = props
      props.fetchFaqCategories(params)
        .then((res) => {
          setCategoryList({
            data: res.data,
            isFetching: false,
          })
        })
        .catch(() => {
          setCategoryList({
            data: [],
            isFetching: false,
          })
        })
    },
    getDetail: props => async (id) => {
      const {
        setData, setImgFile, setCurrentImg,
      } = props

      try {
        const res = await props.fetchFaqDetail(id)
        setData(res)
        setImgFile(res.logo_path)
        setCurrentImg(res.logo_path)
      } catch (err) {
        setData()
        setImgFile()
      }
    },
    handleUpload: props => (info) => {
      const isImage = Helper.checkingFile(info)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (isImage && fileList.length > 0) {
        const base64 = Helper.getBase64(info.file, file => props.setImgFile(file))
        return base64
      }
      return false
    },
    handleSubmit: props => (values) => {
      let payload

      props.setIsSubmit(true)

      if (props.imgFile === props.currentImg) {
        payload = {
          ...values,
        }
        delete payload.logo_file
      } else {
        payload = {
          ...values,
          logo_file: props.imgFile,
        }
      }

      if (props.isEdit) {
        props.updateFaq(props.match.params.id, payload)
          .then(() => {
            message.success('Faq has been updated')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/faq/list')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      } else {
        props.createFaq(payload)
          .then(() => {
            message.success('Faq has been created')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/faq/list')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        match, setIsEdit, getCategoryList, getDetail,
      } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'FAQ Form',
        activePage: 'faq/list',
        activeSubPage: 'faq',
      })

      getCategoryList()

      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormFaqListView)
